module.exports = __webpack_public_path__ + "static/img/A96.9b0d43e0.jpg";